module.exports = __webpack_public_path__ + "img/tally.1e1bdc5c.svg";